import { render, staticRenderFns } from "./AutomationRecipeFlow.vue?vue&type=template&id=5ca085e4&scoped=true&"
import script from "./AutomationRecipeFlow.vue?vue&type=script&lang=js&"
export * from "./AutomationRecipeFlow.vue?vue&type=script&lang=js&"
import style0 from "./AutomationRecipeFlow.vue?vue&type=style&index=0&id=5ca085e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca085e4",
  null
  
)

export default component.exports